export default (that) => [
  {
    field: 'seq',
    width: 50,
    align: 'center',
    fixed: 'left',
    type: 'seq',
  },
  {
    field: 'radio',
    width: 40,
    align: 'center',
    fixed: 'left',
    type: 'radio',
  },
  {
    title: that.$l('form_label_shippingMarkType') || '唛头类型',
    field: 'v_shippingMarkType',
    align: 'center',
    width: 100,
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    title: that.$l('table_label_shippingMarkContext') || '唛头内容',
    align: 'center',
    minWidth: 280,
    slots: { default: 'shippingMarkContext', },
  },
  {
    title: that.$l('table_label_shippingMarkTextEn') || '唛头英文名称',
    field: 'nameEn',
    align: 'center',
    minWidth: 130,
  },
  {
    title: that.$l('table_label_destinationPort') || '关联目的港口',
    field: 'v_destinationPort',
    align: 'center',
    minWidth: 150,
    showHeaderOverflow: true,
    showOverflow: true,
  },
]
